import React, { useEffect, useState, useContext } from "react";
import {
  getDocumentsTable,
  deleteDocumentsTable,
  getUsers,
  getDocumentsTableV2,
  MediaUrl,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditDocumentTable } from "./form";
import {
  Deletemodel,
  Pagination,
  DocumentViewerModal,
} from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";

const DocumentTable = () => {
  const [documentTable, setDocumentTable] = useState([]);
  const [documentType, setdocumentType] = useState([]);
  const [formData, setFormData] = useState({
    subcategory: "",
    category_id: "",
    status: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedDocumentTable, setSelectedDocumentTable] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [addoredit, setaddoredit] = useState();
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rolesPerPage = 10;
  const [filteredTodos, setFilteredTodos] = useState([]);
  const [filterOption, setFilterOption] = useState("");
  const [documentModal, setDocumentModal] = useState(false);
  const [DocumentUrl, setDocumentUrl] = useState("");
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [activeTab, setActiveTab] = useState('Employee');

  useEffect(() => {
    fetchDocuments();
    fetchUsers();
  }, []);

  const fetchDocuments = async (page = 1, title = "") => {
    showLoader();

    try {
      // const response1 = await getDocumentsTable(text, page, '', shop_id);
      let filter = `shop_id=${shop_id}&title=${title}&page=${page}`;
      const response = await getDocumentsTableV2(filter);
      console.log(response);

      if (response.data && response.data.data) {
        setDocumentTable(response.data.data);
        setFilteredTodos(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching document table data:", error);
      hideLoader();
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await getUsers(null);
      if (response.data && response.data.data) {
        setdocumentType(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const openDeleteModel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const openDocumentView = (viewer) => {
    const Url = `${MediaUrl + viewer}`;
    setDocumentUrl(Url);
    setDocumentModal(true);
  };

  // const projectTitles = [...new Set(documentTable.map((item) => item.date))];
  const projectTitles = [...new Set(documentTable.map((item) => new Date(item.date).toISOString().split("T")[0])),];
  

  const handleFilterChange = (selectedTitle) => {
    if (selectedTitle) {
      setFilterOption(selectedTitle);
      setFilteredTodos(
        documentTable.filter(
          (item) =>
            new Date(item.date).toISOString().split("T")[0] === selectedTitle
        )
  
      );
    } else {
      setFilterOption("All Document");
      setFilteredTodos(documentTable); // Reset to show all tasks
    }
  };

  const openAddModal = () => {
    setaddoredit(true);
    setShowEditModal(!showEditModal);
  };

  const openEditModal = (cat) => {
    setSelectedDocumentTable(cat);
    setaddoredit(false);
    setShowEditModal(!showEditModal);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDelete = async () => {
    try {
      await deleteDocumentsTable(deleteID);
      toast.success("Document deleted successfully");
      fetchDocuments(currentPage);
      showDeletemodel(false);
    } catch (error) {
      console.error("Error deleting Document table:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchDocuments(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchDocuments(1, text);
    setCurrentPage(1);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>
            Documents
          </h6>
          {!readonly && (
          <button
            type="button"
            onClick={() => openAddModal()}
            className="btn btn-primary mb-2"
            style={{ fontFamily: "poppins" }}
          >
            Add Documents Table
          </button>
          )}
        </div>
        <hr className="mt-1" />
        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-12 col-lg-12 mb-3 mb-md-2">
              <div className="d-flex justify-content-between">
                <div
                  className="d-flex position-relative"
                  style={{ width: "30%" }}
                >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search..."
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <img
                    src="/assets/images/icons/search.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "18px",
                      pointerEvents: "none",
                    }}
                  />
                </div>
                <div className="dropdown mr-2 border rounded">
                  <button
                    className="btn btn-drop-down dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {filterOption || "Select Filter"}
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleFilterChange("")}
                      >
                        All Document
                      </a>
                    </li>
                    {projectTitles.map((title) => (
                      <li key={title}>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => handleFilterChange(title)}
                        >
                          {title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
                    {/* Approval Status Tabs */}
                    {/* <ul className="nav nav-tabs text-end mb-3">
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'customer' ? 'active' : ''}`}
                            // onClick={() => setActiveTab('customer')}
                        >
                            Customer
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'Employee' ? 'active' : ''}`}
                            // onClick={() => setActiveTab('Employee')}
                        >
                            Employee
                        </button>
                    </li>
                </ul> */}
            <div className="table-responsive">
              <table
                id="example"
                className="table table-striped  table-sm table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    {/* <th>Document Type</th> */}
                    <th>Employee </th>
                    <th>description</th>
                    <th>Document View</th>
                    <th>Issued Date</th>
                    <th>Expiry Date</th>

                    {/* <th>created_by</th> */}

                    {/* <th>Status</th> */}
                    {/* <th>CD</th>
                                        <th>UD</th> */}
                   {!readonly && (<th>Actions</th> )} 
                  </tr>
                </thead>
                <tbody>
                  {filteredTodos.map((subcat, index) => (
                    <tr key={subcat.document_id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{subcat.title}</td>
                      {/* <td>{subcat.document_type_title}</td> */}
                      {/* <td>{subcat.employee_name}</td> */}
                      <td  className="">
                        <div className="text-middle mx-4 d-flex justify-content-start  ">
                          {subcat.employee_name ? (
                            <>
                              <i className="fas mt-1 fa-user me-2 text-primary"></i>
                              {subcat.employee_name}
                            </>
                          ) : (
                            <>
                              <i className="fas mt-1 fa-id-card me-2  text-secondary"></i>
                              {subcat.emp_id || 'N/A'}
                            </>
                          )}
                        </div>
                      </td> 
                      <td>{subcat.description}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => openDocumentView(subcat.file_upload)}
                        >
                          <img
                            src="assets/images/menu/document.png"
                            alt="document"
                            width={30}
                          />
                        </button>
                      </td>

                      <td>{subcat.issued_date}</td>
                      <td>{subcat.expiry_date}</td>
                      {/* <td>{subcat.created_by}</td> */}
                      {/* <td>{subcat.status}</td> */}
                     {!readonly && ( <td>
                        <img
                          src="/assets/images/icons/edit.png"
                          onClick={() => openEditModal(subcat)}
                          height={"16px"}
                        />
                        <img
                          src="/assets/images/icons/delete.png"
                          className="mx-1"
                          onClick={() => openDeleteModel(subcat.document_id)}
                          height={"16px"}
                        />
                      </td> )}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
        </div>
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      {documentModal && (
        <DocumentViewerModal
          setShowModal={setDocumentModal}
          documentUrl={DocumentUrl}
        />
      )}

      <EditDocumentTable
        showModal={showEditModal}
        setShowModal={() => openEditModal()}
        fetchDocumentTable={() => fetchDocuments(currentPage)}
        selectedDocumentTable={selectedDocumentTable}
        AddorEdit={addoredit}
      />
    </div>
  );
};

export default DocumentTable;
